<app-loading-spinner [active]="exporting"
    [customMessage]="'Gerando Relatório. Não feche esta janela...'"
    [persistentMessage]="true"
    [showContinueButton]="true"></app-loading-spinner>
<div class="dash-card">
    <div class="dash-card-header" style="flex-direction: column;">
        <div class="row w-100 no-gutters">
            <div class="col-12">
                <h2 *ngIf="shouldShowContent" class="dashboard-title">
                    Meu departamento
                    <span class="dashboard-area"
                        *ngIf="userArea">{{userArea}}</span>
                </h2>
            </div>
        </div>
    </div>

    <div class="dash-card-body">
        <div class="dash-card-statistics" *ngIf="shouldShowContent">
            <ng-container *ngIf="loadingSummary">
                <div class="col-12 p-0 summary-skeleton-grid">
                    <ngx-skeleton-loader *ngFor="let _ of [1,2,3,4,5,6]"
                        [theme]="{
                        height: '89px',
                        width: '100%',
                        margin:'0'
                    }">
                    </ngx-skeleton-loader>
                </div>
            </ng-container>

            <ng-container *ngIf="!loadingSummary">
                <div class="dash-card-statistics-item">
                    <span class="dash-card-statistics-title">Cedentes</span>
                    <app-spacer [bottom]="4"></app-spacer>
                    <span class="dash-card-statistics-value">{{
                        statistics.assignor }}</span>
                </div>

                <div class="dash-card-statistics-item">
                    <span class="dash-card-statistics-title">Cotistas</span>
                    <app-spacer [bottom]="4"></app-spacer>
                    <span class="dash-card-statistics-value">{{
                        statistics.shareholder }}</span>
                </div>

                <div class="dash-card-statistics-item">
                    <span class="dash-card-statistics-title">Prestadores de
                        Serviços</span>
                    <app-spacer [bottom]="4"></app-spacer>
                    <span class="dash-card-statistics-value">{{
                        statistics.provider }}</span>
                </div>

                <div class="dash-card-statistics-item">
                    <span class="dash-card-statistics-title">Ativos</span>
                    <app-spacer [bottom]="4"></app-spacer>
                    <span class="dash-card-statistics-value">{{
                        statistics.active }}</span>
                </div>

                <div class="dash-card-statistics-item">
                    <span class="dash-card-statistics-title">Inativos</span>
                    <app-spacer [bottom]="4"></app-spacer>
                    <span class="dash-card-statistics-value">{{
                        statistics.inactive }}</span>
                </div>

                <div class="dash-card-statistics-item">
                    <span class="dash-card-statistics-title">Total</span>
                    <app-spacer [bottom]="4"></app-spacer>
                    <span class="dash-card-statistics-value">{{ statistics.total
                        }}</span>
                </div>
            </ng-container>
        </div>

        <!-- Subtítulo abaixo dos cards de summary -->
        <div class="dash-card-subtitle-container" *ngIf="shouldShowContent">
            <h3 class="dash-card-subtitle-title">
                {{ isMaster ? 'Cadastros aguardando aprovação' : 'Aguardando sua
                aprovação' }}
            </h3>
            <p class="dash-card-subtitle-text">
                {{ isMaster ? 'Cadastros de todos os departamentos que estão
                aguardando aprovação' : 'Cadastros no seu departamento
                aguardando aprovação' }}
            </p>
        </div>

        <!-- Tabs abaixo do subtítulo -->
        <div class="dashboard-tabs-container" *ngIf="shouldShowContent">
            <div class="dashboard-tabs">
                <button type="button" class="dashboard-tab"
                    [class.active]="activeTab === 'all'"
                    (click)="onTabChange('all')">
                    Todos
                </button>
                <button type="button" class="dashboard-tab"
                    [class.active]="activeTab === 'new'"
                    (click)="onTabChange('new')">
                    Novos
                </button>
                <button type="button" class="dashboard-tab"
                    [class.active]="activeTab === 'update'"
                    (click)="onTabChange('update')">
                    Atualizações
                </button>
            </div>
        </div>

        <!-- Botões abaixo dos cards de summary -->
        <div class="dash-card-buttons-container" *ngIf="shouldShowContent">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <button type="button" class="sort-button"
                        (click)="refreshData()" [disabled]="loading">
                        <svg-icon src="assets/images/icon-renew.svg"></svg-icon>
                        <span>Atualizar</span>
                    </button>
                </div>

                <div class="d-flex">
                    <app-button-with-dropdown label="Baixar tabela"
                        iconSrc="assets/images/icon_download.svg"
                        [showOptions]="showExportOptions"
                        (toggleShowOptions)="toggleExportOptions()"
                        (onClick)="toggleExportOptions()" [outline]="true"
                        class="export-button mr-3"
                        [disabled]="loading || !users?.length">
                        <button class="dropdown-item"
                            (click)="downloadTable('csv')">Baixar como
                            CSV</button>
                        <button class="dropdown-item"
                            (click)="downloadTable('pdf')">Baixar como
                            PDF</button>
                        <button class="dropdown-item"
                            (click)="downloadTable('xlsx')">Baixar como
                            XLSX</button>
                    </app-button-with-dropdown>

                    <app-button *ngIf="hasFilters" [danger]="true"
                        [outline]="true" (onClick)="resetForm()"
                        class="add-button mr-2" [disabled]="loading">
                        <svg-icon src="assets/images/icon-times.svg"
                            class="filter-clear-icon"></svg-icon>
                        Limpar filtros
                    </app-button>

                    <app-button [inverted]="true"
                        (onClick)="toggleFilterModal()" class="add-button"
                        [disabled]="loading">
                        <svg-icon src="assets/images/icon_filter.svg"
                            class="mr-2">
                        </svg-icon>
                        {{ hasFilters ? 'Editar filtros' : 'Filtrar listagem' }}
                    </app-button>
                </div>
            </div>

            <!-- Tags de filtros aplicados -->
            <div class="col-12 mt-3 px-0"
                *ngIf="hasFilters && appliedFilters.length > 0">
                <div
                    class="d-flex flex-wrap align-items-center justify-content-end">
                    <app-filter-tag *ngFor="let filter of appliedFilters"
                        [label]="filter.label" [value]="filter.value">
                    </app-filter-tag>
                </div>
            </div>
        </div>

        <div class="dash-card-scroll" *ngIf="shouldShowContent">
            <table *ngIf="loadingTable" class="bordered skeleton-table">
                <tbody>
                    <tr *ngFor="let number of [0,1,2]">
                        <td>
                            <div class="dash-card-item">
                                <div class="dash-card-item-initials">
                                    <span>
                                        <ngx-skeleton-loader appearance="circle"
                                            [theme]="{
                                        height: '48px',
                                        width: '48px',
                                        margin: '0',
                                        marginBottom: '0',
                                        marginTop: '0'
                                      }">
                                        </ngx-skeleton-loader>
                                    </span>
                                </div>

                                <app-spacer [right]="16"></app-spacer>

                                <div class="dash-card-item-content">
                                    <div class="dash-card-item-content-title">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '21px',
                                            width: '130px',
                                            margin: '0',
                                            marginBottom: '0',
                                            marginTop: '0'
                                          }">
                                        </ngx-skeleton-loader>
                                    </div>
                                </div>
                            </div>
                        </td>

                        <td>
                            <ngx-skeleton-loader [theme]="{
                                height: '18px',
                                width: '140px',
                                margin: '0',
                                marginBottom: '0',
                                marginTop: '0'
                            }">
                            </ngx-skeleton-loader>
                        </td>

                        <td>
                            <div class="dash-card-item-content">
                                <div class="dash-card-item-content-title">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '21px',
                                        width: '100px',
                                        margin: '0',
                                        marginBottom: '0',
                                        marginTop: '0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                                <div class="dash-card-item-content-subtitle">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '18px',
                                        width: '120px',
                                        margin: '0',
                                        marginBottom: '0',
                                        marginTop: '0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </td>

                        <td>
                            <div class="dash-card-item-content">
                                <div class="dash-card-item-content-title">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '28px',
                                        width: '100px',
                                        borderRadius: '20px',
                                        margin: '0',
                                        marginBottom: '0',
                                        marginTop: '0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </td>

                        <td>
                            <ngx-skeleton-loader [theme]="{
                                height: '28px',
                                width: '90px',
                                borderRadius: '20px',
                                margin: '0',
                                marginBottom: '0',
                                marginTop: '0'
                              }">
                            </ngx-skeleton-loader>
                        </td>

                        <td *ngIf="isMaster">
                            <div class="dash-card-item-content">
                                <div class="dash-card-item-content-title">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '21px',
                                        width: '140px',
                                        margin: '0',
                                        marginBottom: '0',
                                        marginTop: '0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                                <div class="dash-card-item-content-subtitle">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '18px',
                                        width: '140px',
                                        margin: '0',
                                        marginBottom: '0',
                                        marginTop: '0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </td>

                        <td>
                            <div class="dash-card-item-content">
                                <div class="dash-card-item-content-title">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '21px',
                                        width: '140px',
                                        margin: '0',
                                        marginBottom: '0',
                                        marginTop: '0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                                <div class="dash-card-item-content-subtitle">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '18px',
                                        width: '140px',
                                        margin: '0',
                                        marginBottom: '0',
                                        marginTop: '0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </td>

                        <td style="text-align: center; padding: 0 20px;">
                            <ngx-skeleton-loader [theme]="{
                                height: '20px',
                                width: '20px',
                                margin: '0',
                                marginBottom: '0',
                                marginTop: '0'
                              }">
                            </ngx-skeleton-loader>
                        </td>
                    </tr>

                </tbody>
                <app-spacer [bottom]="28"></app-spacer>
            </table>

            <table class="bordered" *ngIf="users.length > 0 && !loadingTable">
                <thead>
                    <tr>
                        <th>Nome / Razão Social</th>
                        <th>Papel</th>
                        <th>Versão</th>
                        <th class="text-left">Criado em</th>
                        <th class="text-left">Estado</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of users">
                        <tr>
                            <td>
                                <div class="dash-card-item">
                                    <button type="button"
                                        class="button row-toggle mr-2"
                                        (click)="toggleRow(item)"
                                        [attr.aria-expanded]="isRowExpanded(item)"
                                        [attr.title]="isRowExpanded(item) ? 'Fechar' : 'Abrir'">
                                        <svg-icon
                                            src="assets/images/icon-up.svg"
                                            fill="#000"
                                            *ngIf="isRowExpanded(item)"></svg-icon>
                                        <svg-icon
                                            src="assets/images/icon-down.svg"
                                            fill="#000"
                                            *ngIf="!isRowExpanded(item)"></svg-icon>
                                    </button>
                                    <div class="dash-card-item-initials">
                                        <span>{{getInitials(item)}}</span>
                                    </div>
                                    <app-spacer [right]="16"></app-spacer>
                                    <div class="dash-card-item-content">
                                        <div
                                            class="dash-card-item-content-title d-flex align-items-center">
                                            {{getDisplayName(item)}}
                                        </div>
                                        <div
                                            class="dash-card-item-content-subtitle">
                                            {{getDocumentOnly(item) || '—'}}
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td [style.max-width]="'300px'">
                                <div class="dash-card-item-content"
                                    *ngIf="getRolesForBadges(item).length">
                                    <div class="role-badges-wrap">
                                        <span
                                            *ngFor="let role of getRolesForBadges(item)"
                                            class="role-badge">
                                            {{ role.applicable_display || role.name || '—' }}
                                        </span>
                                    </div>
                                </div>
                                <span
                                    *ngIf="!getRolesForBadges(item).length"
                                    class="dash-card-item-content-subtitle">—</span>
                            </td>
                            <td>
                                <span [class]="getVersionBadgeClass(item)"
                                    class="version-badge">
                                    {{getVersionLabel(item)}}
                                </span>
                            </td>
                            <td class="text-left">
                                <div class="dash-card-item-content">
                                    <div class="dash-card-item-content-title">
                                        {{getCreatedDate(item)}}</div>
                                    <div
                                        class="dash-card-item-content-subtitle">
                                        {{getCreatedTime(item)}}</div>
                                </div>
                            </td>
                            <td class="text-left">
                                <span
                                    [class]="getEstadoBadgeClass(item)">{{getEstadoAtivoInativo(item)}}</span>
                            </td>
                            <td style="text-align: right;">
                                <div
                                    class="d-flex justify-content-end align-items-center">
                                    <button type="button"
                                        class="button mr-2"
                                        [attr.title]="getRegisterActionTooltip(item)"
                                        (click)="onRegisterActionClick($event, item)">
                                        <svg-icon
                                            src="assets/images/icon-ban.svg"
                                            *ngIf="isRegisterActive(item)"></svg-icon>
                                        <svg-icon
                                            src="assets/images/icon-check.svg"
                                            *ngIf="!isRegisterActive(item)"></svg-icon>
                                    </button>
                                    <a [routerLink]="renderLink(item)"
                                        class="button d-inline-flex align-items-center ml-1"
                                        title="Visualizar">
                                        <svg-icon
                                            src="assets/images/icon-eye.svg"></svg-icon>
                                    </a>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="isRowExpanded(item)" class="details-row">
                            <td [attr.colspan]="6">
                                <table class="details-table">
                                    <thead>
                                        <tr>
                                            <th>Papel</th>
                                            <th>Status</th>
                                            <th>Etapa</th>
                                            <th>Perfil</th>
                                            <th>Criado em</th>
                                            <th>Validade</th>
                                            <th>Estado</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngIf="getRoleControlsList(item).length === 0">
                                            <td colspan="8"
                                                class="dash-card-item-content-subtitle">—</td>
                                        </tr>
                                        <tr
                                            *ngFor="let rc of getRoleControlsList(item)">
                                            <td><span
                                                    class="role-badge">{{getRoleControlPapelName(rc)}}</span>
                                            </td>
                                            <td class="text-left">
                                                <span
                                                    [class]="getRoleControlStatusClass(rc)"
                                                    class="status-badge">{{getRoleControlStatusDisplay(rc)}}</span>
                                            </td>
                                            <td class="text-left">
                                                <ng-container
                                                    *ngIf="isRoleControlEtapaVisible(rc)">
                                                    <div
                                                        *ngIf="rc.current_stage_title"
                                                        class="dash-card-item-content-title">
                                                        {{ rc.current_stage_title }}
                                                    </div>
                                                    <div
                                                        *ngIf="rc.current_stage_description"
                                                        class="dash-card-item-content-subtitle">
                                                        {{ rc.current_stage_description }}
                                                    </div>
                                                    <span
                                                        *ngIf="!rc.current_stage_title && !rc.current_stage_description"
                                                        class="dash-card-item-content-subtitle">—</span>
                                                </ng-container>
                                                <span
                                                    *ngIf="!isRoleControlEtapaVisible(rc)"
                                                    class="dash-card-item-content-subtitle">—</span>
                                            </td>
                                            <td>
                                                <span
                                                    class="role-badge profile-badge"
                                                    [ngStyle]="getRoleControlProfileBadgeStyle(rc)">{{getRoleControlProfile(rc)}}</span>
                                            </td>
                                            <td>{{getRoleControlCreatedAt(rc)}}
                                            </td>
                                            <td>{{getRoleControlValidity(rc)}}
                                            </td>
                                            <td>
                                                <span
                                                    [class]="getRoleControlEstadoClass(rc)">{{getRoleControlEstado(rc)}}</span>
                                            </td>
                                            <td>
                                                <ng-container
                                                    *ngIf="!isRepresentativeRoleControl(rc)">
                                                    <button type="button"
                                                        class="button"
                                                        [attr.title]="getPaperActionTooltip(item, rc)"
                                                        (click)="onPaperActionClick($event, item, rc)">
                                                        <svg-icon
                                                            src="assets/images/icon-ban.svg"
                                                            *ngIf="isRoleActive(item, rc)"
                                                            (click)="onPaperActionClick($event, item, rc)"></svg-icon>
                                                        <svg-icon
                                                            src="assets/images/icon-check.svg"
                                                            *ngIf="!isRoleActive(item, rc)"
                                                            (click)="onPaperActionClick($event, item, rc)"></svg-icon>
                                                    </button>
                                                </ng-container>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </ng-container>
        </tbody>
        </table>

        <ng-container *ngIf="hasFilters">
            <div class="empty-card" *ngIf="users.length === 0 && !loadingTable">
                <div class="img-container">
                    <img src="/assets/images/figure_3d_search.png" alt="icone">
                </div>
                <app-spacer [bottom]="48"></app-spacer>

                <h3>Não encontramos resultados para sua busca</h3>
                <p>
                    Não há registros para o termo digitado, verifique a
                    ortografia ou tente novamente com outras
                    palavras
                </p>
            </div>
        </ng-container>

        <ng-container *ngIf="!hasFilters">
            <div class="empty-card" *ngIf="users.length === 0 && !loadingTable">
                <div class="img-container">
                    <img src="/assets/images/star.png" alt="icone">
                </div>
                <app-spacer [bottom]="48"></app-spacer>

                <h3>Nada por enquanto</h3>
                <p>
                    Até o momento não há cadastros pendentes de aprovação
                    para o seu departamento
                </p>
            </div>
        </ng-container>
    </div>

    <div class="empty-card consultant" *ngIf="!shouldShowContent">
        <div class="img-container">
            <img src="/assets/images/star.png" alt="icone">
        </div>
        <app-spacer [bottom]="48"></app-spacer>

        <h3>Plataforma de cadastro</h3>
        <p>
            Realize consultas através do campo de busca localizada no topo
            da página ;)
        </p>
    </div>

    <div class="pb-4"></div>

</div>
</div>

<div class="dash-card-pagination" *ngIf="shouldShowContent && users.length > 0">
    <app-pagination [data]="users" [count]="count"
        [show]="!loadingTable && !registerStatusSubmitting && !paperStatusSubmitting"
        [offset]="showing_to" (onPageChange)="changePageData($event)"
        [dashPagination]="true" [resultsPerPage]="results_per_page">
    </app-pagination>
</div>

<app-side-modal [active]="newInvite" [title]="renderInviteTitle()"
    (onClose)="closeModal()">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-12" *ngIf="selectedRole === 'provider'">
                <app-select label="Agente" [group]="form" controlName="agent"
                    [items]="agentOptions" [multiple]="true">
                </app-select>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 col-md-6">
                <app-input [group]="form" controlName="name" label="Nome"
                    [helpText]="selectedRole === 'shareholder' ? 'Se pessoa jurídica, inserir a razão social' : 'Se pessoa física, inserir nome completo'">
                </app-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 col-md-6">
                <app-masked-input [group]="form" controlName="document"
                    label="CPF / CNPJ" mask="CPF_CNPJ" [isDocument]="true">
                </app-masked-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <app-input type="email" label="E-mail" [group]="form"
                    controlName="email">
                </app-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12" *ngIf="selectedRole === 'assignor'">
                <app-select label="Fundo de interesse" [group]="form"
                    controlName="fund" [items]="fundOptions">
                </app-select>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12">
                <app-masked-input [group]="form" controlName="due_date"
                    mask="00/00/0000" label="Validade do convite"
                    placeholder="dd/mm/aaaa">
                </app-masked-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12" *ngIf="selectedRole === 'provider'">
                <app-radio [multiple]="true" formControlName="is_approver">
                    <span class="app-radio-text">Delegar poderes de
                        aprovação</span>
                </app-radio>
                <app-spacer [bottom]="16"></app-spacer>
            </div>
        </div>

        <div class="row button-sticky">
            <div class="col-12 col-lg-6">
                <app-button (onClick)="closeModal()" [phantom]="true">
                    Cancelar
                </app-button>
            </div>

            <div class="col-12 col-lg-6">
                <div class="text-right">
                    <app-button (onClick)="sendInvite()" class="add-button"
                        [disabled]="getDisabled()">
                        Disparar convite
                    </app-button>
                </div>
            </div>
        </div>
    </form>
</app-side-modal>


<app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
    [loading]="loading" title="Filtrar listagem"
    [disableApplyButton]="!canApplyFilters" (onClose)="toggleFilterModal()"
    (onApply)="filterUsers()" (onReset)="resetForm()">
    <div class="row">
        <div class="col-12">
            <app-input label="Nome / Razão Social" [group]="filterForm"
                controlName="name" placeholder="Digite">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="document"
                label="CPF / CNPJ" mask="CPF_CNPJ" placeholder="Digite">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-select [items]="currentStageDepartmentOptions"
                [group]="filterForm" controlName="current_stage_department"
                placeholder="Selecione" label="Estágio Atual">
            </app-select>
            <app-spacer [bottom]="32"></app-spacer>
        </div>

        <div class="col-12">
            <h3>Filtrar por data de criação</h3>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
        <div class="col-12 col-lg-6">
            <app-masked-input [group]="filterForm" controlName="created_from"
                mask="00/00/0000" label="De" placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
        <div class="col-12 col-lg-6">
            <app-masked-input [group]="filterForm" controlName="created_to"
                mask="00/00/0000" label="Até" placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <h3>Data de vencimento de cadastro</h3>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
        <div class="col-12 col-lg-6">
            <app-masked-input [group]="filterForm" controlName="expiry_from"
                mask="00/00/0000" label="De" placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
        <div class="col-12 col-lg-6">
            <app-masked-input [group]="filterForm" controlName="expiry_to"
                mask="00/00/0000" label="Até" placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <div class="d-flex align-items-center">
                <app-radio [multiple]="true" formControlName="has_imported">
                    <span style="margin-left: 8px;">Cadastros Importados</span>
                </app-radio>
            </div>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <span class="filter-section-label">Perfil de investimento de
                cotista</span>
            <div class="filter-checkbox-group">
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="profileConservador">
                    <span>Conservador</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="profileModerado">
                    <span>Moderado</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="profileAgressivo">
                    <span>Agressivo</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox"
                        formControlName="profileNaoAplicavel">
                    <span>Não aplicável</span>
                </label>
            </div>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <span class="filter-section-label">Status dos papéis</span>
            <div class="filter-checkbox-group">
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="statusEmAprovacao">
                    <span>Em aprovação</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="statusHomologado">
                    <span>Homologado</span>
                </label>
            </div>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <span class="filter-section-label">Estado do cadastro</span>
            <div class="filter-checkbox-group">
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="estadoCadastroTodos"
                        (change)="onEstadoCadastroChange('todos')">
                    <span>Todos</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="estadoCadastroAtivo"
                        (change)="onEstadoCadastroChange('ativo')">
                    <span>Ativo</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox"
                        formControlName="estadoCadastroInativo"
                        (change)="onEstadoCadastroChange('inativo')">
                    <span>Inativo</span>
                </label>
            </div>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <span class="filter-section-label">Estado dos papéis</span>
            <div class="filter-checkbox-group">
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="estadoTodos"
                        (change)="onEstadoPapeisChange('todos')">
                    <span>Todos</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="estadoAtivo"
                        (change)="onEstadoPapeisChange('ativo')">
                    <span>Ativo</span>
                </label>
                <label class="filter-checkbox-item">
                    <input type="checkbox" formControlName="estadoInativo"
                        (change)="onEstadoPapeisChange('inativo')">
                    <span>Inativo</span>
                </label>
            </div>
        </div>
    </div>
</app-side-filter-modal>

<app-carbon-warning-modal [active]="showRegisterStatusModal"
    [title]="getRegisterActionTitle(selectedRegisterItem)"
    [customContent]="true"
    [contentOverflowVisible]="true"
    [confirmText]="selectedRegisterItem && isRegisterActive(selectedRegisterItem) ? 'Confirmar inativação' : 'Confirmar ativação'"
    [cancelText]="'Cancelar'"
    [loading]="registerStatusSubmitting"
    [disableConfirm]="isRegisterActivationConfirmDisabled()"
    [confirmAction]="confirmRegisterStatusChange.bind(this)"
    [cancelAction]="closeRegisterStatusModal.bind(this)"
    (onClose)="closeRegisterStatusModal()">
    <div class="paper-status-modal register-status-modal">
        <ng-container *ngIf="selectedRegisterItem && isRegisterActive(selectedRegisterItem)">
            <p>
                {{getRegisterActionMessage(selectedRegisterItem)}}
                <strong> {{selectedRegisterItem ?
                    getDisplayName(selectedRegisterItem) : '-'}}</strong>?
            </p>
        </ng-container>

        <ng-container *ngIf="selectedRegisterItem && !isRegisterActive(selectedRegisterItem)">
            <ng-container *ngIf="isRegisterActivationSinglePaper()">
                <p>
                    O cadastro está inativo. Ao confirmar, o papel <strong>{{ getSingleRegisterActivationPaperLabel() }}</strong> será ativo juntamente com o cadastro do usuário
                    <strong>{{ getDisplayName(selectedRegisterItem) }}</strong>. Deseja continuar?
                </p>
            </ng-container>

            <ng-container *ngIf="isRegisterActivationMultiPaper()">
                <p class="register-activate-intro">
                    Para ativar o cadastro, é necessário reativar ao menos um papel. Selecione os papéis abaixo ou marque a opção para reativar todos.
                </p>
                <label class="register-activate-all">
                    <input
                        type="checkbox"
                        [checked]="registerActivateAllPapers"
                        (change)="registerActivateAllPapers = $any($event.target).checked; onRegisterActivateAllToggle()"
                    />
                    Ativar todos os papéis
                </label>
                <div class="register-activate-select-wrap">
                    <app-select
                        [items]="registerActivatePaperSelectItems"
                        [multiple]="true"
                        [group]="registerActivatePapersForm"
                        controlName="paperIds"
                        placeholder="Selecione os papéis"
                        label="Papéis"
                        [readOnly]="registerActivateAllPapers"
                    ></app-select>
                </div>
            </ng-container>
        </ng-container>
    </div>
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showPaperStatusModal"
    [title]="getPaperActionTitle(selectedPaperItem, selectedPaperRole)"
    [customContent]="true"
    [confirmText]="selectedPaperItem && selectedPaperRole && isRoleActive(selectedPaperItem, selectedPaperRole) ? 'Confirmar inativação' : 'Confirmar ativação'"
    [cancelText]="'Cancelar'"
    [loading]="paperStatusSubmitting"
    [confirmAction]="confirmPaperStatusChange.bind(this)"
    [cancelAction]="closePaperStatusModal.bind(this)"
    (onClose)="closePaperStatusModal()">
    <div class="paper-status-modal">
        <p>
            {{getPaperActionMessage(selectedPaperItem, selectedPaperRole)}}
            <strong>{{selectedPaperRole ?
                getRoleLabelForModal(selectedPaperRole) : ''}}</strong> do
            cadastro:
        </p>
        <p class="paper-status-modal-name">
            <strong>{{selectedPaperItem ? getDisplayName(selectedPaperItem) :
                '-'}}</strong>
        </p>
    </div>
</app-carbon-warning-modal>